import api from '../../config/base';
import{
    CREATE_SESSION_ERROR,
    CREATE_SESSION_SUCCESS,
    DELETE_SESSION_ERROR,
    DELETE_SESSION_SUCCESS,
    FETCH_SESSIONS_ERROR,
    FETCH_SESSIONS_SUCCESS,
    UPDATE_SESSION_ERROR,
    UPDATE_SESSION_SUCCESS

} from './types';
export const getAllSessions = () => async (dispatch) => {
    try {
      const res = await api.get('sessions');
    //  console.log(res.data);
      dispatch({
        type: FETCH_SESSIONS_SUCCESS,
        payload:res.data ,
      });
    } catch (error) {
      dispatch({
        type: FETCH_SESSIONS_ERROR,
        payload: error.message,
      });
    }
  };

  export const createSession = (session) => async (dispatch) => {
    try {
      console.log("session",session)
      const res = await api.post('sessions', session);
      dispatch({
        type: CREATE_SESSION_SUCCESS,
        payload: res.data ,
      });
    } catch (error) {
      console.log("error",error)
      dispatch({
        type: CREATE_SESSION_ERROR,
        payload: error.message,
      });
    }
  };
  export const deleteSession = (_id) => async (dispatch) => {
    try {
     // console.log(_id);
      const res = await api.delete(`sessions/${_id}`);
    //  console.log('delete Session' , res);
      dispatch({
        type: DELETE_SESSION_SUCCESS,
        payload: res.data._id,
      });
    } catch (error) {
      alert(error)
    //  console.log(error)
      dispatch({
        type: DELETE_SESSION_ERROR,
        payload: error.message,
      });
    }
  };
  
  export const updateSession = (_id, session) => async (dispatch) => {
    try {
     // console.log('Session' ,_id)
      const res = await api.put(`sessions/${_id}`, session);
      dispatch({
        type: UPDATE_SESSION_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_SESSION_ERROR,
        payload: error.message,
      });
    }
  };